import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/* eslint react/prop-types:"off" */


import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, IntlProvider } from 'react-intl';
import { getTranslator } from '../libs/locale';
export default (function (translations) {
  return function (ComposedComponent) {
    var WrapperComponent = function WrapperComponent(_ref) {
      var intl = _ref.intl,
          rest = _objectWithoutPropertiesLoose(_ref, ["intl"]);

      return /*#__PURE__*/React.createElement(ComposedComponent, Object.assign({
        i18n: intl
      }, rest, {
        t: getTranslator(intl)
      }));
    };

    var InjectedComponent = injectIntl(WrapperComponent);

    var withI18n = /*#__PURE__*/function (_Component) {
      _inheritsLoose(withI18n, _Component);

      var _super = _createSuper(withI18n);

      function withI18n(props) {
        var _this;

        _this = _Component.call(this, props) || this;
        var pageContext = props.pageContext,
            intl = props.intl;

        var _ref2 = pageContext || {},
            locale = _ref2.locale,
            languages = _ref2.languages,
            originalPath = _ref2.originalPath;

        _this.state = {
          intl: intl,
          language: {
            locale: locale,
            languages: languages,
            originalPath: originalPath
          }
        };
        return _this;
      }

      var _proto = withI18n.prototype;

      _proto.getChildContext = function getChildContext() {
        var _this$state = this.state,
            language = _this$state.language,
            intl = _this$state.intl;
        return {
          language: language,
          intl: intl
        };
      };

      _proto.render = function render() {
        var language = this.state.language;
        var locale = language.locale || 'en';
        var messages = translations[locale];
        return /*#__PURE__*/React.createElement(IntlProvider, {
          locale: locale,
          messages: messages
        }, /*#__PURE__*/React.createElement(InjectedComponent, this.props));
      };

      return withI18n;
    }(Component);

    withI18n.childContextTypes = {
      language: PropTypes.object,
      intl: PropTypes.object
    };
    return withI18n;
  };
});